import React from 'react'
import PropTypes from 'prop-types'
import {injectIntl} from 'react-intl'
import {
    Price,
    Currency as CurrencyWrapper,
    PriceMessage,
} from './layout'

import messages from './messages'
import { getTimeUnitMessage } from './getTimeUnitMessage'
import { Flex, Currency } from '@elparking/components'

class ParkingPrice extends React.PureComponent {
    static propTypes = {
        intl: PropTypes.object,
        price: PropTypes.shape({
            amount: PropTypes.number,
            currency: PropTypes.string,
        }),
        priceWrapper: PropTypes.elementType,
        currencyWrapper: PropTypes.elementType,
        priceMessageWrapper: PropTypes.elementType,
        timeUnit: PropTypes.string,
    }

    static defaultProps = {
        priceWrapper: Price,
        currencyWrapper: CurrencyWrapper,
        priceMessageWrapper: PriceMessage,
    }

    renderCurrencyWithTimeUnit = this.renderCurrencyWithTimeUnit.bind(this)

    renderCurrencyWithTimeUnit (timeUnit) {
        const {
            price,
            currencyWrapper: CurrencyWrapper,
            priceWrapper: PriceWrapper,
            intl,
        } = this.props
        return (
            <Flex justifyContent='center'>
                <Currency qty={price} amountWrapper={PriceWrapper} currencyWrapper={CurrencyWrapper} />
                <PriceWrapper>{`/`}{intl.formatMessage(getTimeUnitMessage(timeUnit))}</PriceWrapper>
            </Flex>
        )
    }

    render () {
        const {
            intl,
            price,
            priceMessageWrapper: PriceMessageWrapper,
            currencyWrapper: CurrencyWrapper,
            priceWrapper: PriceWrapper,
            timeUnit,
        } = this.props
        if (price) {
            return (
                timeUnit
                    ? this.renderCurrencyWithTimeUnit(timeUnit)
                    : <Currency qty={price} amountWrapper={PriceWrapper} currencyWrapper={CurrencyWrapper} />
            )
        }

        return (
            <PriceMessageWrapper>
                {intl.formatMessage(messages.full)}
            </PriceMessageWrapper>
        )
    }
}

export default injectIntl(ParkingPrice)
